/** VAL-DENTAL-RISK-GUIDE-1 — markup for the dental guide under Company-specific risk. */
import { csrpGuidance, csrpWarning, type CsrpLine } from './_csrpGuidance'

function Src({ line }: { line: CsrpLine }) {
  return (
    <a href={line.url} target="_blank" rel="noopener noreferrer" className="underline">
      {line.text}
    </a>
  )
}

export function CsrpGuide({ industry, value }: { industry?: string | null; value: string }) {
  const guide = csrpGuidance(industry)
  if (!guide) return null
  const warning = csrpWarning(value, industry)
  return (
    <div className="mt-1 space-y-1 text-xs text-gray-500 sm:col-span-2">
      <p><Src line={guide.range} /></p>
      <p>Signs that support a higher number:</p>
      <ul className="list-disc space-y-0.5 pl-5">
        {guide.signs.map(s => <li key={s.text}><Src line={s} /></li>)}
      </ul>
      <p><Src line={guide.countOnce} /></p>
      <p><Src line={guide.evidence} /></p>
      {warning && <p className="font-medium text-amber-600">{warning}</p>}
    </div>
  )
}
